import { PageScaffold } from "../../shared/ui/PageScaffold";

const adminLinks = [
  { to: "/t/:tenantSlug/teacher/admin", label: "管理ホーム" },
  { to: "/t/:tenantSlug/teacher/admin/videos", label: "動画管理" }
];

export function AdminEventsPage() {
  return (
    <PageScaffold
      title="Admin Events"
      description="イベント一覧画面のプレースホルダーです。"
      links={adminLinks}
    >
      <p>ここに event 一覧を表示します。</p>
    </PageScaffold>
  );
}
